import React from "react";
import {IArenaViewModel} from "../arena-view-model.interface";
import {GameInfo} from "../../../../games/game-info";

export class VoidArenaModel implements IArenaViewModel {
    get arenaName(): string {
        return 'voidArena';
    }

    get listsCount(): number {
        return 0;
    }

    renderArena(): React.ReactElement | null {
        return null;
    }

    renderList(listPosition: number): React.ReactElement | null {
        return null;
    }

    getNextBatchSize(currentListPosition: number): number {
        return 0;
    }

    filterGamesByArenaType(gamesInfo: GameInfo[]): GameInfo[] {
        return [];
    }
}